export default {
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.save_complete': 'Saved!',
  'common.add': 'Add',
  'common.confirm': 'Confirm',
  'common.confirming': 'Confirming...',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.retry': 'Retry',
  'common.loading': 'Loading...',
  'common.login': 'Log in',
  'common.logout': 'Log out',
  'common.signup': 'Sign up',
  'common.email': 'Email',
  'common.password': 'Password',
  'common.dashboard': 'Dashboard',
  'common.fullscreen': 'Fullscreen',
  'common.presentation': 'Presentation',
  'common.copied': 'Copied!',
  'common.copy': 'Copy',
  'time.seconds_one': '{{count}} second',
  'time.seconds_other': '{{count}} seconds',
  'time.minutes_one': '{{count}} minute',
  'time.minutes_other': '{{count}} minutes',
  'time.hours_one': '{{count}} hour',
  'time.hours_other': '{{count}} hours',
  'common.magnification': '{{count}}x',
};
